import { useState, useEffect } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { InnerPages } from '../../components/InnerPages/InnerPages';
import 'react-quill/dist/quill.snow.css';
import { getFormType, getSchoolParam, updateSchoolParam } from '../../utils/functions';
import CustomEditor from '../../components/CustomEditor/CustomEditor';
import { Link, useHistory } from 'react-router-dom';
import React from 'react';

export default function CSIP8KSchoolEdit(props) {
    const history = useHistory();
    const [defaultParams, setDefaultParams] = useState({
        improvePlan: '',
        overviewText: '',
        seattleExcellence: '',
        studentOutcomes: '',
    });
    const [actualParams, setActualParams] = useState({});

    const onChangeValue = (value, key, index = null) => {
        value = typeof value === 'string' ? value : value.target.value;
        const tempFormParams = { ...defaultParams, ...actualParams };
        if (index !== null) {
            if (!tempFormParams[key]) {
                tempFormParams[key] = [];
            }
            tempFormParams[key][index] = value;
        } else {
            tempFormParams[key] = value;
        }
        setActualParams(tempFormParams);
    };

    useEffect(() => {
        const getAndSetFormType = async () => {
            const response = await getFormType('CSIP8KSchool');

            if (response.template) {
                setDefaultParams(response.template);
            }
        };

        const getFormData = async () => {
            const response = await getSchoolParam(props.school._id, 'CSIP8KSchool');

            if (response) {
                if (response.data) {
                    setActualParams(response?.data);
                }
            }
        };

        getAndSetFormType();
        getFormData();
    }, []);

    const onSubmit = async (e) => {
        e.preventDefault();
        const response = await updateSchoolParam(props.school._id, actualParams, 'CSIP8KSchool');

        if (response._id) {
            history.push(`/csip/`);
        }
    };

    const getValue = (key) => {
        return actualParams[key] ? actualParams[key] : defaultParams[key] ? defaultParams[key] : '';
    };

    async function onChangePage() {
        await updateSchoolParam(props.school._id, actualParams, 'CSIP8KSchool');
    }
    return (
        <>
            <Header title={'2023-26 Continuous School Improvement Plan (C-SIP) K-8 School Edit'} />
            <main className={'edit-container container'}>
                <div className={'edit-form-info'}>
                    <h3>
                        <Link to={'/'}>Dashboard</Link>
                    </h3>
                    <h3>
                        <Link to={'/CSIP'}>Schools</Link>
                    </h3>
                </div>
                <div className={'edit-form-info'}>
                    <h3>
                        <Link to={'/'}>Dashboard</Link>
                    </h3>
                </div>
                <InnerPages
                    onChangePage={onChangePage}
                    afterLeftButtons={
                        <button className={'main-button'} onClick={(e) => onSubmit(e)}>
                            Save
                        </button>
                    }
                >
                    <div className="csip-page">
                        <h2>Purpose</h2>
                        <div className="tab">
                            <p>
                                The Continuous School Improvement Plan (C-SIP) is a product of a collaborate inquiry
                                that includes a comprehensive needs assessment led by school leaders with school staff
                                and in collaboration with district staff. The C-SIP provides an overview of district and
                                school priority areas, student outcome goals, measures, student outcome focused
                                governance alignment, strategies, activities, progress monitoring, and budget
                                allocations.
                            </p>
                        </div>
                        <div className="tab-header">
                            <h4>School Data and Building Leadership Team Members and Partners</h4>
                        </div>

                        <div className="horizontal-tab">
                            <div className="tab-item">
                                <div className="tab-header">School Name:</div>
                                <input readOnly={true} className="tab-value" value={props.school?.name}></input>
                            </div>
                            <div className="tab-item">
                                <div className="tab-header">Principal:</div>
                                <input
                                    className="tab-value"
                                    value={getValue('schoolPrincipal')}
                                    onChange={(e) => onChangeValue(e, 'schoolPrincipal')}
                                ></input>
                            </div>
                            <div className="tab-item">
                                <div className="tab-header">
                                    Members of the Building Leadership Team and Parent/Guardian Partners:
                                </div>
                                <input
                                    className="tab-value"
                                    value={getValue('buildingLeadershipMembers')}
                                    onChange={(e) => onChangeValue(e, 'buildingLeadershipMembers')}
                                ></input>
                            </div>
                            <div className="tab-item">
                                <div className="tab-header">Community Partners (Community Based Organizations):</div>
                                <input
                                    className="tab-value"
                                    value={getValue('communityPartners')}
                                    onChange={(e) => onChangeValue(e, 'communityPartners')}
                                ></input>
                            </div>
                        </div>
                        <div className="tab">
                            <CustomEditor
                                placeholder={`[Copy School Photo Here] 
[Insert link to School Report]
[Insert link to School Climate Survey]`}
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('schoolReport')}
                                onChange={(e) => onChangeValue(e, 'schoolReport')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h4>School Overview</h4>
                            </div>

                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('schoolOverview')}
                                onChange={(e) => onChangeValue(e, 'schoolOverview')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h4>Seattle Excellence - Culture of Equity and Educational Justice</h4>
                            </div>

                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('cultureEquity')}
                                onChange={(e) => onChangeValue(e, 'cultureEquity')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h4>Student Outcomes Focused Governance</h4>
                            </div>

                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('studentOutcomesGovernance')}
                                onChange={(e) => onChangeValue(e, 'studentOutcomesGovernance')}
                            />
                        </div>
                    </div>
                    <div className="csip-page">
                        <div className="tab">
                            <h3>Priority Area: Learning Environments - Joyful, Safe, Anti-Racist</h3>
                            <CustomEditor
                                className="tab-content"
                                value={getValue('priorityAreaLearningEnvironments')}
                                onChange={(e) => onChangeValue(e, 'priorityAreaLearningEnvironments')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>Learning Environments Measures and Targets</div>
                            <div className="tab">
                                <div className="tab-header">
                                    <h5>Three-year Goal:</h5>
                                </div>
                                <CustomEditor
                                    className="tab-content"
                                    value={getValue('paleThreeYearGoal')}
                                    onChange={(e) => onChangeValue(e, 'paleThreeYearGoal')}
                                />
                                <div className="tab-header">
                                    <h5>One-year Goal:</h5>
                                </div>
                                <CustomEditor
                                    className="tab-content"
                                    value={getValue('paleoneYearGoal')}
                                    onChange={(e) => onChangeValue(e, 'paleoneYearGoal')}
                                />
                            </div>
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>Student Outcome Focused Governance</div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('paleStudentOutcomeGovernance')}
                                onChange={(e) => onChangeValue(e, 'paleStudentOutcomeGovernance')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Evidence of alignment to student outcome focused governance:</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('envionmentCommunityOutcomeGovernance')}
                                onChange={(e) => onChangeValue(e, 'envionmentCommunityOutcomeGovernance')}
                            />
                        </div>
                    </div>
                    <div className="csip-page">
                        <div className="tab">
                            <div className={'tab-header'}>
                                Learning Environments Data Reflections and Needs Assessment
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('paleLearningEnvironmentsData')}
                                onChange={(e) => onChangeValue(e, 'paleLearningEnvironmentsData')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Evidence of alignment to student outcome focused governance:</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('envionmentCommunityOutcomeGovernance')}
                                onChange={(e) => onChangeValue(e, 'envionmentCommunityOutcomeGovernance')}
                            />
                        </div>
                    </div>
                    <div className="csip-page">
                        <div className="tab">
                            <div className={'tab-header'}>Learning Environments Strategies</div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('paleLearningEnvironmentsStrategies')}
                                onChange={(e) => onChangeValue(e, 'paleLearningEnvironmentsStrategies')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Culturally responsive strategies, processes, or procedures staff will implement to
                                    meet the Three-Year Learning Environments Goal:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('learningEnvCulturallyResponsive')}
                                onChange={(e) => onChangeValue(e, 'learningEnvCulturallyResponsive')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Professional learning plan that will support implementation of the culturally
                                    responsive strategies, processes, or procedures:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('learningEnvProfessionalLearning')}
                                onChange={(e) => onChangeValue(e, 'learningEnvProfessionalLearning')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Components of Multiple Tiered System of Support (MTSS) that reflect Inclusive
                                    Practices and create the conditions for students who receive student support
                                    services to be successful in the general education setting:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('learningEnvMTSSReflect')}
                                onChange={(e) => onChangeValue(e, 'learningEnvMTSSReflect')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Components of Multiple Tiered System of Support (MTSS) that meet the
                                    social-emotional and behavioral needs of students:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('learningEnvMTSSMeet')}
                                onChange={(e) => onChangeValue(e, 'learningEnvMTSSMeet')}
                            />
                        </div>
                    </div>

                    <div className="csip-page">
                        <div className="tab">
                            <h3>
                                Priority Area: Classroom Instruction and Academic Success—Graduation and Advanced Course
                                Completion
                            </h3>
                            <CustomEditor
                                className="tab-content"
                                value={getValue('classroomInstructionAcademicSuccess')}
                                onChange={(e) => onChangeValue(e, 'classroomInstructionAcademicSuccess')}
                            />
                        </div>

                        <div className="tab-header">
                            <h4>Classroom Instruction and Academic Success Measures and Targets</h4>
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>School Three-year Goal:</h5>
                            </div>
                            <div>
                                <CustomEditor
                                    className={'tab-content'}
                                    theme="snow"
                                    value={getValue('ciasClassroomThreeYearGoal')}
                                    onChange={(e) => onChangeValue(e, 'ciasClassroomThreeYearGoal')}
                                />
                            </div>
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>School One-year Goal:</h5>
                            </div>
                            <div>
                                <CustomEditor
                                    className={'tab-content'}
                                    theme="snow"
                                    value={getValue('ciasClassroomOneYearGoal')}
                                    onChange={(e) => onChangeValue(e, 'ciasClassroomOneYearGoal')}
                                />
                            </div>
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Use of formative assessments and data to improve instruction and continuous
                                    improvement aligned to the three-year and one-year goals:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasClassroomFormativeAssessment')}
                                onChange={(e) => onChangeValue(e, 'ciasClassroomFormativeAssessment')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Use of formative assessments and data to improve instruction and continuous
                                    improvement aligned to the three-year and one-year goals:
                                </h5>
                            </div>
                            <div>
                                <CustomEditor
                                    className={'tab-content'}
                                    theme="snow"
                                    value={getValue('ciasFormativeAssessments')}
                                    onChange={(e) => onChangeValue(e, 'ciasFormativeAssessments')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="csip-page">
                        <div className="tab">
                            <div className={'tab-header'}>Student Outcome Focused Governance</div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasClassroomOutcomeGovernance')}
                                onChange={(e) => onChangeValue(e, 'ciasClassroomOutcomeGovernance')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Evidence of alignment to student outcome focused governance:</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasEvidenceOfAlignment')}
                                onChange={(e) => onChangeValue(e, 'ciasEvidenceOfAlignment')}
                            />
                        </div>
                    </div>
                    <div className="csip-page">
                        <div className="tab">
                            <div className={'tab-header'}>
                                Classroom Instruction and Academics Data Reflections and Needs Assessment
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasClassroomDataReflections')}
                                onChange={(e) => onChangeValue(e, 'ciasClassroomDataReflections')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Data illuminating that students are experiencing high quality classroom instruction
                                    and academic success:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasDataIlluminatingAcademicSuccess')}
                                onChange={(e) => onChangeValue(e, 'ciasDataIlluminatingAcademicSuccess')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Evidence of disproportionate and/or systemic inequities in classroom instruction and
                                    academic success that surface based on quantitative/qualitative data:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasEvidenceOfSystemicInequities')}
                                onChange={(e) => onChangeValue(e, 'ciasEvidenceOfSystemicInequities')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Processes, procedures, and/or strategies proving to be powerful and effective for
                                    student outcomes:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasEvidenceOfPowerfulStudentOutcomes')}
                                onChange={(e) => onChangeValue(e, 'ciasEvidenceOfPowerfulStudentOutcomes')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Professional learning that is proving to be powerful and effective for student
                                    outcomes:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasProfessionalLearningOutcomes')}
                                onChange={(e) => onChangeValue(e, 'ciasProfessionalLearningOutcomes')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Strategies, processes, or procedures and/or professional learning, or other supports
                                    that are no longer being implemented due to minimal impact on student outcomes:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasStrategiesProcesses')}
                                onChange={(e) => onChangeValue(e, 'ciasStrategiesProcesses')}
                            />
                        </div>
                    </div>
                    <div className="csip-page">
                        <div className="tab">
                            <div className={'tab-header'}>Classroom Instruction and Academics Strategies</div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasClassroomStrategies')}
                                onChange={(e) => onChangeValue(e, 'ciasClassroomStrategies')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Culturally responsive strategies, processes, or procedures staff will implement to
                                    meet the Three-Year Classroom Instruction and Academic Success Goal:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasHighlyCapableServices')}
                                onChange={(e) => onChangeValue(e, 'ciasHighlyCapableServices')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Professional learning that will support implementation of culturally responsive
                                    strategies, process, or procedures:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasHighlyCapableServices')}
                                onChange={(e) => onChangeValue(e, 'ciasHighlyCapableServices')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Components of Multiple Tiered System of Support (MTSS) that reflect Inclusive
                                    Practices and create the conditions for students who receive student support
                                    services to be successful in the general education setting:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasHighlyCapableServices')}
                                onChange={(e) => onChangeValue(e, 'ciasHighlyCapableServices')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Components of Multiple Tiered System of Support (MTSS) that meet the academic needs
                                    of students:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasHighlyCapableServices')}
                                onChange={(e) => onChangeValue(e, 'ciasHighlyCapableServices')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Highly Capable Services</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasHighlyCapableServices')}
                                onChange={(e) => onChangeValue(e, 'ciasHighlyCapableServices')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Expanded Learning Opportunities:</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasExpandedLearningOpportunities')}
                                onChange={(e) => onChangeValue(e, 'ciasExpandedLearningOpportunities')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Homework Policy:</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('ciasHomeworkPolicy')}
                                onChange={(e) => onChangeValue(e, 'ciasHomeworkPolicy')}
                            />
                        </div>
                    </div>

                    <div className="csip-page">
                        <div className="tab">
                            <h3>Priority Area: Family and Community Engagement</h3>
                            <CustomEditor
                                className="tab-content"
                                value={getValue('priorityAreaFamilyCommunityEngagement')}
                                onChange={(e) => onChangeValue(e, 'priorityAreaFamilyCommunityEngagement')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>School Three-year Goal:</h5>
                            </div>
                            <div>
                                <CustomEditor
                                    className={'tab-content'}
                                    theme="snow"
                                    value={getValue('familyCommunityThreeYearGoal')}
                                    onChange={(e) => onChangeValue(e, 'familyCommunityThreeYearGoal')}
                                />
                            </div>
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>School One-year Goal:</h5>
                            </div>
                            <div>
                                <CustomEditor
                                    className={'tab-content'}
                                    theme="snow"
                                    value={getValue('familyCommunityOneYearGoal')}
                                    onChange={(e) => onChangeValue(e, 'familyCommunityOneYearGoal')}
                                />
                            </div>
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>Student Outcome Focused Governance</div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('familyCommunityOutcomeGovernance')}
                                onChange={(e) => onChangeValue(e, 'familyCommunityOutcomeGovernance')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Evidence of alignment to student outcome focused governance:</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('familyCommunityOutcomeGovernanceEvidence')}
                                onChange={(e) => onChangeValue(e, 'familyCommunityOutcomeGovernanceEvidence')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                Family and Community Engagement Data Reflections and Needs Assessment
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('familyCommunityDataReflections')}
                                onChange={(e) => onChangeValue(e, 'familyCommunityDataReflections')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Data illuminating that school staff are leveraging assets within the Black community
                                    and communities of color through deeper partnerships, convening and creating
                                    opportunities for families and community leaders to be partners in student's
                                    educational experiences:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('familyDatailluminating')}
                                onChange={(e) => onChangeValue(e, 'familyDatailluminating')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Professional learning proving to foster educator development about the power of
                                    parents in transforming and improving teacher-parent communication and opportunities
                                    for dialogue and understanding:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('familyProfessionalLearning')}
                                onChange={(e) => onChangeValue(e, 'familyProfessionalLearning')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Culturally responsive strategies, processes, and/or procedures proving to support
                                    shared power and parent/guardian leadership and is centering families' voices are
                                    various levels:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('familyCulturallyResponsive')}
                                onChange={(e) => onChangeValue(e, 'familyCulturallyResponsive')}
                            />
                        </div>
                    </div>
                    <div className="csip-page">
                        <div className="tab">
                            <div className={'tab-header'}>Family and Community Engagement Strategies</div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('familyCommunityEngagementStrategies')}
                                onChange={(e) => onChangeValue(e, 'familyCommunityEngagementStrategies')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Professional learning plan that will support implementation of educator development
                                    about the power of parents in transforming and improving teacher-parent
                                    communication and opportunities for dialogue and understanding:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('familyProfessionalLearningStrategy')}
                                onChange={(e) => onChangeValue(e, 'familyProfessionalLearningStrategy')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Culturally responsive strategies, processes, and/or procedures that support sharing
                                    power with families to support new structures of parent leadership and centering
                                    families' voices are various levels:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('familyCulturalResponsiveStrategy')}
                                onChange={(e) => onChangeValue(e, 'familyCulturalResponsiveStrategy')}
                            />
                        </div>
                    </div>

                    <div className="csip-page">
                        <div className="tab">
                            <h3>Priority Area: Culturally Responsive Workforce</h3>
                            <CustomEditor
                                className="tab-content"
                                value={getValue('priorityAreaCulturallyResponseiveWorkforce')}
                                onChange={(e) => onChangeValue(e, 'priorityAreaCulturallyResponseiveWorkforce')}
                            />
                        </div>
                        <div className="tab">
                            <div className={'tab-header'}>Student Outcome Focused Governance</div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('culturallyResponsiveGovernance')}
                                onChange={(e) => onChangeValue(e, 'culturallyResponsiveGovernance')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Evidence of alignment to student outcome focused governance:</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('workforcEvidenceOfAlignment')}
                                onChange={(e) => onChangeValue(e, 'workforcEvidenceOfAlignment')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                Culturally Responsive Workforce Data Reflections and Needs Assessment
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('workforceDataReflections')}
                                onChange={(e) => onChangeValue(e, 'workforceDataReflections')}
                            />
                        </div>
                    </div>
                    <div className="csip-page">
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Data that is illuminating evidence of belonging and relationships:</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('dataIlluminatingEvidence')}
                                onChange={(e) => onChangeValue(e, 'dataIlluminatingEvidence')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Data that is illuminating a culturally responsive and anti-racist work environment:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('dataIlluminatingCulturally')}
                                onChange={(e) => onChangeValue(e, 'dataIlluminatingCulturally')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Data that is illuminating evidence of staff safety, bias, and/or wellbeing:</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('dataIlluminatingStaffSafety')}
                                onChange={(e) => onChangeValue(e, 'dataIlluminatingStaffSafety')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>Evidence of leadership opportunities and support:</h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('leadershipOpportunitiesEvidence')}
                                onChange={(e) => onChangeValue(e, 'leadershipOpportunitiesEvidence')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Professional learning that is proving powerful and effective for developing a
                                    culturally responsive workforce:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('workforceProffesionalLearning')}
                                onChange={(e) => onChangeValue(e, 'workforceProffesionalLearning')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>Culturally Responsive Workforce Strategies</div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('workforceStrategies')}
                                onChange={(e) => onChangeValue(e, 'workforceStrategies')}
                            />
                        </div>
                    </div>
                    <div className="csip-page">
                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Culturally responsive strategies, processes, and/or procedures that support
                                    Belonging and Relationships:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('culturallyResponsiveStrategiesRelationships')}
                                onChange={(e) => onChangeValue(e, 'culturallyResponsiveStrategiesRelationships')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Culturally responsive strategies, processes, and/or procedures that support a
                                    culturally responsive and anti-racist work environment:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('culturallyResponsiveWorkEnvironment')}
                                onChange={(e) => onChangeValue(e, 'culturallyResponsiveWorkEnvironment')}
                            />
                        </div>

                        <div className="tab">
                            <div className={'tab-header'}>
                                <h5>
                                    Culturally responsive strategies, processes, and/or procedures that support
                                    leadership opportunities:
                                </h5>
                            </div>
                            <CustomEditor
                                className={'tab-content'}
                                theme="snow"
                                value={getValue('culturallyResponsiveLeadership')}
                                onChange={(e) => onChangeValue(e, 'culturallyResponsiveLeadership')}
                            />
                        </div>
                    </div>

                    <div className="csip-page">
                        <h2>Budget Allocations to Support Continuous Improvement</h2>
                        <p className="table-header">
                            The following table describes how the school allocates funds to support and improve student
                            learning.
                        </p>

                        <table>
                            <tr>
                                <th>Academic Year</th>
                                <th>Funding Type: (Combined or Specific use)</th>
                                <th>Funding Source</th>
                                <th>Amount</th>
                                <th>How will funds improve student learning? Limit 100 words.</th>
                            </tr>
                            <tr>
                                <td>
                                    <input
                                        type="text"
                                        name="academic_year"
                                        placeholder="Enter Academic Year"
                                        value={getValue('budget_academic_year1')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_academic_year1');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="funding_type"
                                        placeholder="Enter Funding Type"
                                        value={getValue('budget_funding_type1')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_funding_type1');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="funding_source"
                                        placeholder="Enter Funding Source"
                                        value={getValue('budget_funding_source1')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_funding_source1');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        name="amount"
                                        placeholder="Enter Amount"
                                        value={getValue('budget_amount1')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_amount1');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="description"
                                        maxLength="100"
                                        placeholder="Enter Description"
                                        value={getValue('budget_description1')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_description1');
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input
                                        type="text"
                                        name="academic_year"
                                        placeholder="Enter Academic Year"
                                        value={getValue('budget_academic_year2')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_academic_year2');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="funding_type"
                                        placeholder="Enter Funding Type"
                                        value={getValue('budget_funding_type2')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_funding_type2');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="funding_source"
                                        placeholder="Enter Funding Source"
                                        value={getValue('budget_funding_source2')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_funding_source2');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        name="amount"
                                        placeholder="Enter Amount"
                                        value={getValue('budget_amount2')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_amount2');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="description"
                                        maxLength="100"
                                        placeholder="Enter Description"
                                        value={getValue('budget_description2')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_description2');
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input
                                        type="text"
                                        name="academic_year"
                                        placeholder="Enter Academic Year"
                                        value={getValue('budget_academic_year3')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_academic_year3');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="funding_type"
                                        placeholder="Enter Funding Type"
                                        value={getValue('budget_funding_type3')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_funding_type3');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="funding_source"
                                        placeholder="Enter Funding Source"
                                        value={getValue('budget_funding_source3')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_funding_source3');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        name="amount"
                                        placeholder="Enter Amount"
                                        value={getValue('budget_amount3')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_amount3');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        maxLength="100"
                                        placeholder="Enter Description"
                                        value={getValue('budget_description3')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_description3');
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input
                                        type="text"
                                        name="academic_year"
                                        placeholder="Enter Academic Year"
                                        value={getValue('budget_academic_year4')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_academic_year4');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="funding_type"
                                        placeholder="Enter Funding Type"
                                        value={getValue('budget_funding_type4')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_funding_type4');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="funding_source"
                                        placeholder="Enter Funding Source"
                                        value={getValue('budget_funding_source4')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_funding_source4');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        name="amount"
                                        placeholder="Enter Amount"
                                        value={getValue('budget_amount4')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_amount4');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="description"
                                        maxLength="100"
                                        placeholder="Enter Description"
                                        value={getValue('budget_description4')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_description4');
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input
                                        type="text"
                                        name="academic_year"
                                        placeholder="Enter Academic Year"
                                        value={getValue('budget_academic_year5')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_academic_year5');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="funding_type"
                                        placeholder="Enter Funding Type"
                                        value={getValue('budget_funding_type5')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_funding_type5');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="funding_source"
                                        placeholder="Enter Funding Source"
                                        value={getValue('budget_funding_source5')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_funding_source5');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        name="amount"
                                        placeholder="Enter Amount"
                                        value={getValue('budget_amount5')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_amount5');
                                        }}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="description"
                                        maxLength="100"
                                        placeholder="Enter Description"
                                        value={getValue('budget_description5')}
                                        onChange={(e) => {
                                            onChangeValue(e, 'budget_description5');
                                        }}
                                    />
                                </td>
                            </tr>
                        </table>
                    </div>
                </InnerPages>
            </main>
            <Footer />
        </>
    );
}
